$bog_ui_skeleton $mol_view
